import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { StorageUtils } from '../../../utils/storage-utils';
import { RestService } from '../../../utils/rest-service';
import { JsonContainer } from '../../../utils/json-container';
import { Company } from './company';
import { FileUpload } from '../../ok-core/photo/file-upload';


@Injectable()
export class CompanyExtService extends RestService {

    constructor(private client: HttpClient, private storageUtils: StorageUtils) {
        super(client, 'companyExt', storageUtils);
    }

    deleteCertified(id: string, callback: (result: JsonContainer) => void) {
        this.executeDelete('deleteCertified/' + id, callback)
    }

    listActiveCustomers(callback: (result: JsonContainer, roles: Company[]) => void) {
        this.executeGet('listActiveCustomers', callback)
    }

    listActiveMEICustomers(callback: (result: JsonContainer, roles: Company[]) => void) {
        this.executeGet('listActiveMEICustomers', callback)
    }

    adminListSIMEI(callback: (result: JsonContainer, companies: Company[]) => void) {
        this.executeGet('adminListSIMEI', callback)
    }
    saveAvatar(fileUpload: FileUpload, userId: string, callback: (result: JsonContainer, list: any) => void) {
        this.executePut(`uploadAvatar/${userId}`, fileUpload, callback)
    }

    linkPlanCompany(namePlan: string, document: string, callback: (result: JsonContainer) => void) {
        this.executePut(`linkCompanyPlan/${namePlan}/${document}`, null, callback)
    }

    updateCompany(document: string, callback: (result: JsonContainer) => void) {
        this.executeGet(`/updateCompany/${document}`, callback)
    }

    load(id: string, callback: (result: JsonContainer, comp: Company) => void) {
        this.executeGet(`loadCompany/${id}`, callback)
    }

    sendEmailUserBlock(companyId: String, callback: (result: JsonContainer, email) => void) {
        this.executePost('sendEmailUserBlock', companyId, callback)
    }

    sendEmailChangeCertified(companyId: String, callback: (result: JsonContainer, email) => void) {
        this.executePost('sendEmailChangeCertified', companyId, callback)
    }

}
